function utils(
  state = {
    loader: new Map(),
    loaderTimeout: true,
    avatars: [],
    toasts: [],
    showLauncherGuide: true,
    isUserOnline: false,
  },
  action
) {
  switch (action.type) {
    case 'START_LOAD':
      const afterStartLoader = new Map(state.loader);
      afterStartLoader.set(action.key, action.value);
      return {
        ...state,
        loader: afterStartLoader,
        loaderTimeout: !action.noTimeout,
      };
    case 'FINISH_LOAD':
      const afterFinishLoader = new Map(state.loader);
      afterFinishLoader.delete(action.key);
      return { ...state, loader: afterFinishLoader };
    case 'ADD_TOAST':
      if (action.dismissable) {
        return { ...state, toasts: [...state.toasts, action.toast()] };
      } else {
        action.toast();
        return state;
      }
    case 'REMOVE_TOASTS':
      state.toasts.forEach(t => action.toast(t));
      return { ...state, toasts: [] };
    case 'RECEIVE_AVATARS':
      return { ...state, avatars: action.avatars };
    case 'LAUNCHER_GUIDE':
      return { ...state, showLauncherGuide: action.value };
    case 'IS_USER_ONLINE':
      return { ...state, isUserOnline: action.value };
    default:
      return state;
  }
}

export default utils;
